


























































import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { SortOrder } from '@/store/types/general.types';
import { JbicGroupListColumns } from '@/store/modules/admin/types/group.types';

// components
import BaseTable from '@/components/BaseTable.vue';
import BasePagination from '@/components/base/BasePagination.vue';
import BaseLoading from '@/components/base/BaseLoading.vue';
import { PaginationMixin } from '@/components/base/pagination.mixin';
import SortableTableHeader from '@/components/SortableTableHeader.vue';
import GroupRow from '@/views/JBIC/components/GroupRow.vue';

@Component({
  components: {
    BaseTable,
    BasePagination,
    BaseLoading,
    SortableTableHeader,
    GroupRow
  }
})
export default class GroupsList extends mixins(PaginationMixin) {
  sortHeaders = [
    { placeholder: 'Name', sortColumn: 'name', sort: true },
    { placeholder: 'Region', sort: false },
    { placeholder: 'Country', sort: false },
    { placeholder: 'Unique Members', sort: false }
  ];

  @Prop() public items!: JbicGroupListColumns[];
  @Prop(Number) public currentPage!: number;
  @Prop(Number) public totalNumberOfPage!: number;
  @Prop(Number) public totalCount!: number;
  @Prop(Boolean) public isFirstPage!: boolean;
  @Prop(Boolean) public isLastPage!: boolean;
  @Prop(Number) public startItemIndex!: number;
  @Prop(Number) public endItemIndex!: number;
  @Prop(String) public sortColumn!: string;
  @Prop(String) public sortOrder!: SortOrder;
  @Prop(Boolean) public expandGroupFilter!: boolean;

  mounted() {}

  get groups() {
    return this.items || [];
  }

  get firstLvlGroups() {
    return this.items?.filter((item) => !item.path.includes('.'));
  }

  getChildren(group: JbicGroupListColumns) {
    const path = group.path;
    return this.groups.filter((g) => g.path === path + '.' + g.groupId);
  }

  public getSortOrderOfColumn(columnName: string) {
    if (this.sortColumn === columnName) {
      return this.sortOrder;
    }
    return SortOrder.ASC;
  }

  public onClickHeaderColumn(columnName: string) {
    if (this.sortColumn === columnName) {
      return this.$emit('sort', {
        sortColumn: columnName,
        sortOrder:
          this.sortOrder === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC
      });
    }
    this.$emit('sort', {
      sortColumn: columnName,
      sortOrder: SortOrder.DESC
    });
  }
}
